import { render } from "./controlledGate.vue?vue&type=template&id=205e2edf&scoped=true"
import script from "./controlledGate.vue?vue&type=script&lang=js"
export * from "./controlledGate.vue?vue&type=script&lang=js"

import "./controlledGate.vue?vue&type=style&index=0&id=205e2edf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205e2edf"]])

export default __exports__